module.exports = __webpack_public_path__ + "img/farming-by-numbers--lamb.8b9123bd.png";